export function generateVideoPoster(file: File): Promise<string> {
  const captureTime = 1;

  return new Promise((resolve, reject) => {
    if (!file || !(file instanceof File)) {
      reject(new Error('El archivo proporcionado no es válido'));
      return;
    }

    const video = document.createElement('video');
    const source = URL.createObjectURL(file);
    video.src = source;
    video.crossOrigin = 'anonymous';
    video.muted = true;
    video.playsInline = true;

    video.addEventListener('loadeddata', () => {
      video.currentTime = captureTime; // Captura un frame en el tiempo especificado
    });

    video.addEventListener('seeked', () => {
      try {
        const canvas = document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        const ctx = canvas.getContext('2d');
        ctx?.drawImage(video, 0, 0, canvas.width, canvas.height);

        resolve(canvas.toDataURL('image/jpeg'));
      } catch (error) {
        reject(error);
      } finally {
        URL.revokeObjectURL(source);
      }
    }, { once: true });

    video.addEventListener('error', () => {
      URL.revokeObjectURL(source);
      reject(new Error('Error al cargar el video'));
    }, { once: true });
  });
}
